import React from "react";

export default function Loading({
  size,
  className,
}: {
  size?: number;
  className?: string;
}) {
  const s = size || 40;
  const scale = 1 / (80 / s);
  return (
    <div style={{ width: `${s}px`, height: `${s}px` }} className={className}>
      <div
        className="lds-spinner"
        style={{
          transform: `scale(${scale}, ${scale}) translateX(-${
            80 * scale
          }px) translateY(-${80 * scale}px)`,
        }}
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
